import React, { useEffect, useState } from 'react';
import { Typography, Card, Row, Col, Statistic } from 'antd';
import { CheckCircleOutlined, SettingOutlined, WalletOutlined, WarningOutlined } from '@ant-design/icons';
import { settingsApi } from '../../api/settings';

const { Title } = Typography;

const Dashboard: React.FC = () => {
  const [activeCount, setActiveCount] = useState(0);
  const [pausedCount, setPausedCount] = useState(0);

  useEffect(() => {
    const load = async () => {
      try {
        const settings = await settingsApi.getAll();
        const active = settings.filter((s) => s.status === 'ACTIVE').length;
        const paused = settings.filter((s) => s.status === 'PAUSED').length;
        setActiveCount(active);
        setPausedCount(paused);
      } catch {
        // 무시 (대시보드는 부가 정보)
      }
    };
    load();
  }, []);

  return (
    <div>
      <Title level={2}>대시보드</Title>
      <Row gutter={16} style={{ marginTop: 24 }}>
        <Col span={6}>
          <Card>
            <Statistic
              title="Connector 상태"
              value="대기중"
              prefix={<CheckCircleOutlined style={{ color: '#999' }} />}
              valueStyle={{ color: '#999' }}
            />
          </Card>
        </Col>
        <Col span={6}>
          <Card>
            <Statistic
              title="활성 설정"
              value={activeCount}
              prefix={<SettingOutlined />}
              valueStyle={{ color: '#52c41a' }}
            />
          </Card>
        </Col>
        <Col span={6}>
          <Card>
            <Statistic
              title="일시중지"
              value={pausedCount}
              prefix={<WalletOutlined />}
              valueStyle={{ color: '#faad14' }}
            />
          </Card>
        </Col>
        <Col span={6}>
          <Card>
            <Statistic
              title="24h 에러"
              value={0}
              prefix={<WarningOutlined />}
              valueStyle={{ color: '#ff4d4f' }}
            />
          </Card>
        </Col>
      </Row>
      <div style={{ marginTop: 32, color: '#999' }}>
        TODO: 실시간 활동, C# 커넥터 연결 상태, 차트 추가
      </div>
    </div>
  );
};

export default Dashboard;
